import { createI18n } from 'vue-i18n';
import zhLocale from './locales/zh.json';
import enLocale from './locales/en.json';
import ruLocale from './locales/ru.json';

const messages = {
  zh: zhLocale,
  en: enLocale,
  ru: ruLocale
};

// Get the browser language or use Chinese as default
const getBrowserLanguage = () => {
  const browserLang = navigator.language.split('-')[0];
  return messages[browserLang] ? browserLang : 'zh';
};

// Create the i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: localStorage.getItem('language') || getBrowserLanguage(),
  fallbackLocale: 'zh',
  messages
});

export default i18n;
